import {
  haulierOptions,
  sendingSiteOptions,
  receivingSiteOptions,
  loadTypeOptions,
  trailerTypeOptions,
  tagOptions
} from "./BookingFilterForm";

export default function reconcileFilters(appliedFilters, bookings) {
  const optionsByKey = {
    haulier: haulierOptions(bookings),
    sendingSite: sendingSiteOptions(bookings),
    receivingSite: receivingSiteOptions(bookings),
    loadType: loadTypeOptions(bookings),
    trailerType: trailerTypeOptions(bookings),
    tag: tagOptions(bookings)
  };

  const reconciled = { ...appliedFilters };

  Object.entries(optionsByKey).forEach(([key, options]) => {
    if (Array.isArray(reconciled[key]) && reconciled[key].length > 0) {
      const validValues = new Set(options.map(o => o.value));
      reconciled[key] = reconciled[key].filter(v => validValues.has(v.value));
    }
  });

  return reconciled;
}
